import { ActionDefinition } from "@/components/automations/types"

export const meetingActions: ActionDefinition[] = []
